import React from 'react'
import {
  FlowLabel,
  LabelCloseWrapper,
  StyledCloseButton,
  NavigationWrapper,
} from './component.styles'
import BackLink from './BackLink'
import PropTypes from 'prop-types'

const ModalHeader = ({
  flowLabel,
  handleClose,
  handleGoBack,
  showBackButton = true,
}) => {
  return (
    <NavigationWrapper>
      <div>
        {showBackButton && <BackLink onClick={handleGoBack}>Back</BackLink>}
      </div>
      <LabelCloseWrapper>
        {flowLabel && <FlowLabel>{flowLabel}</FlowLabel>}
        <StyledCloseButton
          dataTestId="modal-close-button"
          onClick={handleClose}
        />
      </LabelCloseWrapper>
    </NavigationWrapper>
  )
}

ModalHeader.propTypes = {
  flowLabel: PropTypes.string,
  handleClose: PropTypes.func.isRequired,
  handleGoBack: PropTypes.func.isRequired,
  showBackButton: PropTypes.bool,
}

export default ModalHeader
